
export function formatPrice(text){
    
    let number = text.replace(",",".");

    return number;
}